import { render, staticRenderFns } from "./SpecificationMessages.vue?vue&type=template&id=69e5d41c"
import script from "./SpecificationMessages.vue?vue&type=script&lang=js"
export * from "./SpecificationMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports